module.exports = __webpack_public_path__ + "img/invoice.9af652f7.svg";